Greenmile.RouteDetail = Greenmile.RouteDetail || {};
Greenmile.RouteDetail.ResequenceColumnsToGrid = (function () {

    function ResequenceColumnsToGrid () {

        Greenmile.GridColumns.Resequence.apply(this, arguments);

        this.url = 'form/ProactiveRouteOpt/index';

    }

    return ResequenceColumnsToGrid;

})();
